module.exports = __webpack_public_path__ + "img/task.5923884d.svg";